export default __webpack_public_path__ + "static/beer-cb6cfcee0ebe5ea77fa10f1107e5dfc7.jpg";